module.exports = __webpack_public_path__ + "img/table-equal.ecf5af4b.svg";